import apiConfig from "../config/api";

const apiEmpresas = `${apiConfig.apiUri}api/accessmanagement/company`;
const apiCompany = `${apiConfig.apiUri}api/company/`;
const getToken = () => localStorage.getItem("AccessToken");

var companyArray = [];

for (let i = 0; i < 20; i++) {
  companyArray.push({
    companyName: "Company "+ i,
    companyGroup: "Sodexo S.A",
    companySegment: "Gran Cliente",
    companySubsidiary: i % 2 ? true : false
  })
}

companyArray = [
  {
    CompanyRut: "12345678-9",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "20510913-7",
    companyName: "Empresa A",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "21404324-6",
    companyName: "Empresa B",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "24565809-5",
    companyName: "Empresa C",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "61979830-9",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "69150600-2",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "70360010-6",
    companyName: "Empresa D",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "70360100-6",
    companyName: "ACHS",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "70360111-1",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76005780-0",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76102252-0",
    companyName: "CargoBill",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76125316-6",
    companyName: "CUMINAO Y HERNANDEZ LIMITADA",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76144594-4",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76366637-9",
    companyName: "KOMATSU FINANCE CHILE SOCIEDAD ANONIMA",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "76575844-0",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "77394420-2",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "77824870-0",
    companyName: "EPYSA BUSES LTDA.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "78423860-1",
    companyName: "",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "79556490-K",
    companyName: "SODEXO INVERSIONES SOCIEDAD ANONIMA",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "79646620-0",
    companyName: "MASTERLINE S.A.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "79746250-0",
    companyName: "ELABORADORA DE ALIMENTOS FRUTALE",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "85651300-9",
    companyName: "KOEHN Y YAVAR LTDA.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "87949500-8",
    companyName: "Glasstech S.A.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "94623000-6",
    companyName: "SODEXO CHILE SOCIEDAD ANONIMA",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "94627000-8",
    companyName: "PARQUE ARAUCO S.A.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96529310-8",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96550960-7",
    companyName: "SODEXO SERVICIOS SOCIEDAD ANONIMA",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96556930-8",
    companyName: "SODEXO SOL DE MOTIVACION CHILE SOCIEDAD",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96656760-0",
    companyName: "Empresa",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96915470-6",
    companyName: "TRANSCATERER S.A.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  },
  {
    CompanyRut: "96947020-9",
    companyName: "EMPRESAS HITES S.A.",
    companyGroup: "Sodexo S.a",
    companySegment: "Gran Cliente",
    companySubsidiary: true,
    "Active": "1"
  }
];

companyArray = companyArray.map((e, i) => {e.companySubsidiary = i % 2 ? true : false; return e;})

export const getAllCompanies = () =>
  ({
    status: 200,
    Data: companyArray
  })
  /*fetch(`${apiEmpresas}/get/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });*/

export const getCompanyApi = (data) =>
    fetch(`${apiCompany}searchCompany/${data}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
        "Authorization": `Bearer ${getToken()}`,
      }
    });

export const createCompanyApi = (name, description) =>
  fetch(`${apiEmpresas}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    },
    body: JSON.stringify({
      Name: name,
      Description: description,
    })
  });

export const updateCompanyApi = (idCompany, name, description, active) =>
  fetch(`${apiEmpresas}/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    },
    body: JSON.stringify({
      Active: active,
      IdCompany: idCompany,
      Name: name,
      Description: description,
    })
  });

export const deleteCompanyApi = (idCompany) =>
  fetch(`${apiEmpresas}/delete/${idCompany}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });
